export default "__VITE_ASSET__BTMRNI8N__"